import script from "./select-box.vue?vue&type=script&setup=true&lang=js"
export * from "./select-box.vue?vue&type=script&setup=true&lang=js"

import "./select-box.vue?vue&type=style&index=0&id=6c6481b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c6481b0"]])

export default __exports__